import React, { useEffect, useState } from "react";
import styles from "./scss/failed.module.scss";
import { Tooltip, Modal  } from 'antd';
import ProfileAvatarGroup from "./profileavatargroup";
import { useSelector } from "react-redux";
import { contacts, initialStateModel, leftsideChats, LoginState } from "../../../models/model";
import moment from "moment";
//import { sortByTimeStamp,getTimeFormat } from "../../../base/utils";
import { DraftService } from "../../../base/draftService";
import { URButton } from "../../../shared/widgets/button";
import { useHistory } from "react-router";
import { SocketChatService } from "../../../base/socketChatService";
import { filesUploadApiSocket, generateChatID, userInfo } from "../../../base/socketChatService/utils";
import { ChatService } from "../../../base/chatService";

export default function FailedListsLeft(props:any) {
  const setFilteredLayer = ()=>{
    props.setFilteredLayer("default");
  };
  const contactList: leftsideChats = useSelector((state: initialStateModel) => state.recentchatReducer);
  //const timeStampDetails = sortByTimeStamp(contactList.failedContact);
  const contactListDetails: contacts = useSelector((state: initialStateModel) => state.contactReducer);
  const loginDetails: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [failed, setFailed] = useState<any>();
  const history = useHistory();
  const handleCancel = () =>{
    setIsDelete(false);
  }
  const deleteAction = (deleteData:any) =>{
    setIsDelete(false);
    DraftService.removedFailedContact(deleteData,"delete");
  }
  useEffect(()=>{

  },[contactList.failedContact])
  let workContact = contactListDetails?.workContactsnew;
  let teamContact = contactListDetails?.teamContacsnew;
  let sipid = '';

  return (
    <>

      <div className={`fadeIn ${styles.failedmain}`}>
        <div className={styles.rightbartop}>
          <div className={styles.lefts}>
            Failed <b>{contactList.failedContact?.length}</b>
          </div>
          <div className={styles.rights}>
            <Tooltip mouseEnterDelay={0.5}  placement="top" title="Close">
              <span className="icon_close"onClick={setFilteredLayer}></span></Tooltip>
          </div>
        </div>

        <div className={styles.rightbarbottom}>
        
          {/* {Object.keys(timeStampDetails) && Object.keys(timeStampDetails).length>0 && 
           Object.keys(timeStampDetails).map((value:any,index:any)=>{
            const timestampToday = moment();
            //const tomorrow  = moment().add(1, 'days');
            const yesterday = moment().subtract(1, 'days');
            const isToday = moment(parseInt(value))<timestampToday;
            const isYesterday = moment(parseInt(value))<yesterday;
            let workContact = contactListDetails?.workContactsnew;
            let teamContact = contactListDetails?.teamContacsnew;
            let sipid = '';
          return(<div key={index}> */}
     
            {Array.isArray(contactList?.failedContact)&&contactList?.failedContact?.length >0 && contactList.failedContact.map((values:any,index:any)=>{
             
              let contactsDetail = values.type===1? workContact[values.to]:teamContact["con"+values.chatId];
              let decide = false;
               if((sipid!==contactsDetail.sip_login_id && values.type===1) || (values.type===2 
                && sipid!==contactsDetail.team_id)){
                  decide = true;
                  sipid=contactsDetail.sip_login_id;
                } else {
                  sipid=contactsDetail.team_id;
                  decide =false
                }
           
              const timestampToday = moment(values?.timestamp).format("DD MMM YYYY");;
              var today = moment(new Date()).format("DD MMM YYYY");
              const yesterday = moment().subtract(1, 'days').format('DD MMM YYYY');
              const timeTooltip = (timestampToday === yesterday ? "Yesterday at " : timestampToday === today?"Today at ": "");
           
            return(<>
<div className={styles.failedlist} key={index}>
      {decide &&  <div className={styles.toplayer}>
              
              <><ProfileAvatarGroup contactDetail={values.type===1? values?.fromcaller_details
              :teamContact["con"+values.chatId]} profileSize={38}></ProfileAvatarGroup>
                <h3>You<span className="icon_strokearrowright"></span>
                  <b>
                  {loginDetails.userdetails?.caller_id === values?.fromcaller_details?.caller_id
                                ? "You" :
                                values?.fromcaller_details?.caller_id?.length <= 10 ?
                                values?.fromcaller_details?.caller_id :
                                  values?.fromcaller_details?.caller_id?.substring(0, 10) + "..."} 
                    </b> <span className={styles.dates}>{moment(values?.timestamp).format("D MMM")}</span> </h3></>
              </div>}
              <div className={styles.topbottomlayer}>
              <div className={styles.lefts}>
                <span className="icon_failedfill"></span><br />
                <Tooltip  mouseEnterDelay={0.5} placement="top" title={timeTooltip + ""+moment(values?.timestamp).format('hh:mm A')}>
                  <span className={styles.timeHover}>{moment(values?.timestamp).format('hh:mm')}</span>
                </Tooltip>
              </div>
              <div className={styles.hoverdiv}>
                <ul>
                  <li onClick={()=>{
                    values.contactsDetail = contactsDetail;
                    setIsDelete(true);
                    setFailed(values);
                    }}><Tooltip  mouseEnterDelay={0.5} placement="top" title="Delete"><span className="icon_delete"></span></Tooltip></li>
                  <li onClick={()=>{
                     var chatService = new SocketChatService(userInfo().fromID, userInfo().domainId);
                     //let chatDetail ={chatId:generateChatID(userInfo().fromID, contactsDetail?.sip_login_id?.toString())};
                     if(values.type===1){
                      let chatDetail ={chatId:generateChatID(userInfo().fromID, contactsDetail?.sip_login_id?.toString())};

                      if(values.files){
                        filesUploadApiSocket(values?.files, values?.msgText);
                          chatService.openChatWindow(values.type===1? values?.fromcaller_details
                        :teamContact["con"+values.chatId],history,chatDetail);
                      } else {
                        chatService.NewChat(values?.message?.body,contactsDetail);
                        chatService.openChatWindow(values.type===1? values?.fromcaller_details
                               :teamContact["con"+values.chatId],history,chatDetail);
                      }
                      
                    } else  if(values?.contactDetail?.team_id){
                      chatService.openChatWindow(values.type===1? values?.fromcaller_details
                        :teamContact["con"+values.chatId],history);
                      chatService.sendGroupChat(values?.message?.body,contactsDetail);
                    }
                    DraftService.removedFailedContact(values,"send");
                   
                     ChatService.editDraft("");
                  }}><Tooltip  mouseEnterDelay={0.5} placement="top" title="Resend"><span className="icon_sendoutline"></span></Tooltip></li>
                </ul>
              </div>
              <p>{values?.message?.body}</p>
            </div></div></>)})}
          {/* </div>)})} */}
          <Modal visible={isDelete}
        className={`${styles.clearchatmodal} ${"modaloverwrite"}`}>
        <span onClick={handleCancel} className={`icon_close ${styles.cursorTop}`} />
        <h2>Delete this Failed Message?</h2>
        <p>You will not be able to retrieve this conversation history with {failed?.contactsDetail?.team_id ?
          failed?.contactsDetail?.team_name :
          failed?.contactsDetail?.caller_id} once you delete the chat</p>
        <div className={styles.footersection}>
          <URButton className="urButton buttonWhite buttonMd mr8" onClick={handleCancel} name="Cancel"></URButton>
          <URButton className="urButton buttonRed buttonMd" onClick={()=>{deleteAction(failed)}} name="Delete Chat"></URButton>
        </div>
      </Modal>
          {/* <div className={styles.failedlist}>
            <div className={styles.topbottomlayer}>
              <div className={styles.lefts}>
                <span className="icon_failedfill"></span><br />
                <Tooltip placement="top" title="Today at 12.20 PM">
                  <span className={styles.timeHover}>12.30</span>
                </Tooltip>
              </div>
              <p>We’ve invited you to the spreadsheet we did yesterday,
                but in case we will put it here for u guys me know,
                if everything seems to be clear for you. We can schedule the hangout meeting late, if you want.</p>
            </div>
          </div> */}

          {/* <div className={styles.failedlist}>
            <h6>Sending...</h6>
            <div className={styles.toplayer}>
            <ProfileAvatarGroup contactDetail={value.contactDetail}></ProfileAvatarGroup>
            </div>
            <div className={styles.topbottomlayer}>
              <div className={styles.lefts}>
                <span className="icon_failedfill"></span><br />
                <Tooltip placement="top" title="Today at 12.20 PM">
                  <span className={styles.timeHover}>12.30</span>
                </Tooltip>
              </div>
              <p>We’ve invited you to the spreadsheet we did yesterday,
                but in case we will put it here for u guys me know, if everything seems to be clear for you.
                We can schedule the hangout meeting late, if you want.</p>
            </div>
          </div> */}

        </div>
      </div>

    </>
  );
};

